// extracted by mini-css-extract-plugin
export var closeButton = "_he-2";
export var closeButtonIcon = "_he-3";
export var lightboxContent = "_he-1";
export var lightboxOverlay = "_he-0";